var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPivotal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 130 90",
    style: {
      enableBackground: "new 0 0 130 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#007D68;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M38.2,36.2h-3.7v-3.7h3.7V36.2z M38.2,57h-3.8V38.8h3.8V57z M59.8,38.8l-5.2,15.7c-0.9,2.6-2.5,2.9-3.8,2.9 c-1.9,0-3.1-0.9-3.8-2.9l-4.3-13.1H41v-2.6h4.5L50,53.4c0.2,0.6,0.3,1,0.9,1c0.6,0,0.7-0.4,0.9-1l4.5-14.6L59.8,38.8z M68.9,38.8 c4.8,0,8.2,3.2,8.2,7.9v2.9c0,4.7-3.4,7.9-8.2,7.9s-8.2-3.2-8.2-7.9v-2.9C60.8,42.1,64.1,38.8,68.9,38.8 M68.9,54.5 c2.9,0,4.7-2.2,4.7-4.9v-2.9c0-2.7-1.8-4.9-4.7-4.9c-3.1,0-4.7,2.2-4.7,4.9v2.9C64.2,52.2,66,54.5,68.9,54.5 M106.9,39.4 c-1.9-0.5-4.8-0.8-6.9-0.8c-4.9,0-8,3.2-8,8.2v2c0,5.1,3.1,8.2,8,8.2c0.1,0,1,0,1.4-0.1v-3c-0.1,0-1.2,0.1-1.4,0.1 c-2.7,0-4.5-2.1-4.5-5.2v-2c0-3.1,1.8-5.2,4.5-5.2c1.2,0,3,0.1,3.6,0.2l0.2,0.1V57h3.7V40C107.6,39.7,107.6,39.6,106.9,39.4  M111.2,32.5h3.8V57h-3.8V32.5z M83.8,34.9v3.9h6.1v2.9h-6.1v10.6c0,1.6,1.1,1.7,2.6,1.7h3.5V57h-4.8c-3.5,0-5.1-1.5-5.1-4.7v-17 L83.8,34.9z M21.6,32.6H15v24.5h4.1V36.2h2.1c0.5,0,0.9,0,1.3,0.1c3.4,0.1,5,1.1,5,3.8v0.3c0,2.5-1.3,4.1-4.9,4.1 c-0.4,0-0.9-0.1-0.9-0.1v3.4h0.9c5.2,0,8.9-2.1,8.9-7.4V40C31.5,34.5,27.4,32.6,21.6,32.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPivotal);
export default __webpack_public_path__ + "static/media/Pivotal.5a42dabf782318f796f12baba8ab1af0.svg";
export { ForwardRef as ReactComponent };